import React from 'react'
import './App.css'
import Header from '../components/templates/header'
import Main from '../components/Main/Main'

export default props => 
    <React.Fragment>
        <Header></Header>
        <Main />
    </React.Fragment>